var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"a-app"},[_c('router-view'),_c('loading',{attrs:{"loading":_vm.loading,"loaded":!_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }